import { Component, inject } from "@angular/core";
import { ReactiveFormsModule, FormControl } from "@angular/forms";
import { debounceTime, map } from "rxjs/operators";
import { takeUntilDestroyed } from "@angular/core/rxjs-interop";
import { JumpstartComponentsModule } from "@wk/components-v3-angular17";
import { WkTranslatePipe } from "@shared/utils";
import { WkDataTableSearchService } from "./data-table-search.service";

@Component({
    selector: "wk-data-table-searchbar",
    templateUrl: "./data-table-searchbar.component.html",
    styleUrl: "./data-table-searchbar.component.scss",
    imports: [WkTranslatePipe, ReactiveFormsModule, JumpstartComponentsModule],
    host: {
        class: "wk-data-table__searchbar",
    },
})
export class WkDataTableSearchbar<TItem> {
    protected readonly dataTableSearchService = inject<WkDataTableSearchService<TItem>>(WkDataTableSearchService);

    protected searchControl = new FormControl("");

    constructor() {
        this.searchControl.valueChanges
            .pipe(
                debounceTime(150),
                map((v) => v?.trim() ?? ""),
                takeUntilDestroyed(),
            )
            .subscribe((value) => this.dataTableSearchService.searchValue.set(value));
    }
}
